import { createIcon } from '@chakra-ui/react'

export const DirectoryIcon = createIcon({
  displayName: 'DirectoryIcon',
  viewBox: '0 0 12 14',
  path: (
    <svg
      width="11.67"
      height="9.17"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3335 12.8337H1.16683V1.16699"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})
